export const id = {
  profile: {
    taskDetailLayout: 'Tampilan Detail Task',
    selectTaskDetailLayout: 'Tampilan Detail Task',
    layoutScroll: 'Scroll',
    layoutScrollDesc: 'Semua bagian dalam satu halaman panjang',
    layoutTabs: 'Tab',
    layoutTabsDesc: 'Dibagi ke tab Detail, Dokumen, Checker & Report',
    title: 'Profil',
    personalInfo: 'Info Pribadi',
    notifications: 'Notifikasi',
    faceId: 'Face ID',
    language: 'Bahasa',
    logout: 'Keluar',
    loggingOut: 'Sedang keluar...',
    currentLanguage: 'Indonesia',
    profileUpdated: 'Profil berhasil diperbarui',
    failedUpdate: 'Gagal memperbarui profil',
    editPersonalInfo: 'Ubah Info Pribadi',
    name: 'Nama',
    phone: 'Nomor Telepon',
    email: 'Email',
    passwordOptional: 'Kata Sandi (opsional)',
    selectLanguage: 'Pilih Bahasa',
    ringtone: 'Nada Dering',
    selectRingtone: 'Pilih Nada Dering',
    preview: 'Pratinjau',
    ringtoneClassic: 'Klasik',
    ringtoneIphone: 'iPhone',
    ringtoneGentle: 'Lembut',
    ringtoneDigital: 'Xylophone',
    ringtoneBeep: 'Beep (Default)',
    english: 'Inggris',
    indonesian: 'Indonesia',
    changePhoto: 'Ubah Foto Profil',
    fromGallery: 'Pilih dari Galeri',
    takePhoto: 'Ambil Foto',
    cropTitle: 'Sesuaikan Foto',
    cropHint: 'Geser & cubit untuk menyesuaikan',
    cropConfirm: 'Gunakan Foto',
    photoUpdateFailed: 'Gagal mengupload foto',
  },
  common: {
    save: 'Simpan',
    cancel: 'Batal',
    confirm: 'Konfirmasi',
    delete: 'Hapus',
    ok: 'OK',
    loading: 'Memuat...',
    processing: 'Memproses...',
    saving: 'Menyimpan...',
    deleting: 'Menghapus...',
    submitting: 'Mengirim...',
    saveProgress: 'Simpan Progres',
    savingProgress: 'Menyimpan Progres...',
    submit: 'Kirim',
    success: 'Berhasil',
    error: 'Gagal',
    warning: 'Peringatan',
    goBack: 'Kembali',
    search: 'Cari...',
    description: 'Deskripsi',
    location: 'Lokasi',
    createdBy: 'Dibuat Oleh',
    attachments: 'Lampiran',
    required: 'Wajib',
    optional: 'Opsional',
    others: 'Lainnya',
    pdfPreviewNotSupported: 'Pratinjau PDF tidak didukung di peramban ini.',
    accessDenied: 'Akses Ditolak',
    days: 'Hari',
    hours: 'Jam',
    minutes: 'Menit',
    updateAvailable: 'Ada pembaruan tersedia.',
    updateNow: 'Perbarui Sekarang',
    updating: 'Memperbarui aplikasi...',
  },
  offline: {
    backOnline: 'Kembali online',
    syncing: 'Menyinkronkan {count} data…',
    offlineMode: 'Mode Offline',
    pendingItems: '{count} data menunggu',
    share: '↑ Bagikan',
    sharedSuccess: '✓ Berhasil dibagikan',
    savedToDownloads: '✓ Tersimpan di Downloads',
    exportFailed: 'Gagal mengekspor',
    shareExportTitle: 'Bagikan File Export',
    fileSavedToDownloads: '✓ File tersimpan di folder Downloads',
    shareFile: 'Bagikan File',
    shareFileDesc: 'Kirim via WhatsApp, Email, dll. (dengan file ter-attach)',
    howToShare: 'Cara berbagi file:',
    howToShareDesc: 'Buka File Manager → folder Downloads → tekan tahan file {filename} → pilih Bagikan / Share → pilih WhatsApp atau Email',
    close: 'Tutup',
    cancelFailedTitle: 'Batalkan Data Gagal?',
    cancelFailedDesc: 'Data yang gagal terkirim akan dihapus permanen dari antrian. Pastikan Anda sudah mengekspor filenya jika masih diperlukan.',
    no: 'Tidak',
    yesCancelBtn: 'Ya, Batalkan',
    failedBannerMsg: '{count} data gagal terkirim — ekspor dan kirimkan ke admin',
    cancelFailedTooltip: 'Batalkan data gagal',
    cancelFailedBtn: '✕ Batalkan',
  },
  form: {
    chooseTaskType: 'Pilih Jenis Tugas',
    chooseClient: 'Pilih Klien',
    searchClient: 'Cari klien...',
    chooseVessel: 'Pilih Kapal',
    searchVessel: 'Cari kapal...'
  },
  section: {
    requiredAttachments: 'Checklist Tugas',
  },
  signIn: {
    welcome: 'Selamat Datang Kembali!',
    emailPlaceholder: 'brileyhenderson@mail.com',
    passwordPlaceholder: '••••••••',
    button: 'Masuk',
    signingIn: 'Sedang masuk...',
    validation: {
      fillAll: 'Mohon isi semua kolom',
      validEmail: 'Mohon masukkan email yang valid',
      passwordLength: 'Kata sandi minimal 6 karakter',
    }
  },
  tenantSelect: {
    title: 'Pilih Workspace',
    subtitle: 'Pilih workspace untuk masuk',
    loading: 'Sedang masuk...',
    back: 'Kembali ke login',
  },
  forgotPassword: {
    title: 'Lupa Password',
    subtitle: 'Masukkan email yang terdaftar. Kami akan mengirimkan link reset password melalui WhatsApp.',
    emailLabel: 'Alamat Email',
    emailPlaceholder: 'email@anda.com',
    send: 'Kirim Link Reset',
    sending: 'Mengirim...',
    successTitle: 'Link Terkirim!',
    successMessage: 'Jika email ini terdaftar, link reset password telah dikirim ke nomor WhatsApp yang terdaftar.',
    backToLogin: 'Kembali ke Login',
    linkText: 'Lupa password?',
  },
  resetPassword: {
    title: 'Buat Password Baru',
    subtitle: 'Masukkan password baru Anda di bawah ini.',
    newPassword: 'Password Baru',
    confirmPassword: 'Konfirmasi Password',
    submit: 'Simpan Password',
    submitting: 'Menyimpan...',
    success: 'Password berhasil diperbarui! Silakan masuk kembali.',
    mismatch: 'Password tidak cocok.',
    minLength: 'Password minimal 8 karakter.',
    invalidToken: 'Link reset ini tidak valid atau sudah kadaluarsa.',
  },
  createTask: {
    title: 'Buat Tugas',
    checkAll: 'Pilih Semua',
    uncheckAll: 'Hapus Semua',
    searchChecklist: 'Cari checklist...',
    descriptionPlaceholder: 'Deskripsi...',
    totalDuration: 'Total Estimasi Waktu',
    manualDurationCheckbox: 'Input durasi secara manual',
    manualDurationPlaceholder: 'Durasi dalam menit',
    startDate: 'Tanggal Mulai',
    manualDurationLabel: 'Durasi',
    attachment: 'Lampiran Tugas (Opsional)',
    tapToUpload: 'Ketuk untuk unggah dokumen',
    followUpFor: 'Tugas Lanjutan untuk',
    isUrgent: 'Tandai sebagai Mendesak (Urgent)',
    isMaintenance: 'Tandai sebagai Maintenance',
    checker: 'Pemeriksa (Opsional)',
    chooseChecker: 'Pilih Pemeriksa',
    button: 'Buat Tugas',
    alerts: {
      missingUserId: 'Gagal membuat tugas: ID Pengguna hilang. Silakan coba masuk lagi.',
      fillRequired: 'Mohon isi semua kolom yang wajib',
      success: 'Tugas berhasil dibuat!',
      failed: 'Gagal membuat tugas',
      fetchClientsFailed: 'Gagal memuat daftar client. Cek koneksi Anda lalu coba muat ulang halaman ini.',
      fetchVesselsFailed: 'Gagal memuat daftar vessel. Cek koneksi Anda lalu coba muat ulang halaman ini.',
    },
    noChecklistFound: 'Tidak ada checklist yang cocok.'
  },
  taskDetails: {
    tabDetail: 'Detail',
    tabDocuments: 'Dokumen',
    tabChecker: 'Checker',
    tabReport: 'Report',
    tabNeedsAction: 'Perlu tindakan Anda',
    tabDocumentsEmpty: 'Belum ada dokumen untuk task ini',
    tabReportEmpty: 'Belum ada laporan task',
    title: 'Detail Tugas',
    currentStatus: 'Status Saat Ini',
    assignTo: 'Tugaskan ke',
    attachment: 'Lampiran Tugas',
    searchUser: 'Cari pengguna...',
    noSpecificAttachments: 'Tidak ada konfigurasi checklist tugas.',
    taskType: 'Jenis Tugas',
    createdDate: 'Tanggal Dibuat',
    notFound: 'Tugas Tidak Ditemukan',
    notFoundDesc: 'Tugas yang Anda cari tidak ada atau telah dihapus.',
    totalDuration: 'Total Estimasi Waktu',
    estimatedDuration: 'Estimasi Waktu',
    processingTime: 'Waktu Pengerjaan',
    approvedBy: 'Disetujui oleh',
    completedDate: 'Tanggal Selesai',
    assignedBy: 'Ditugaskan Oleh',
    assignedTo: 'Ditugaskan Ke',
    checker: 'Pemeriksa',
    taskReports: 'Laporan Tugas',
    reviewedBy: 'Ditinjau oleh',
    submittedBy: 'Dilaporkan oleh',
    notes: 'Catatan',
    followUpTask: 'Tugas Lanjutan',
    followUpOf: 'Lanjutan dari',
    createFollowUp: 'Buat Tugas Lanjutan',
    additionalAttachments: 'Lampiran Tambahan',
    downloadFile: 'Unduh Berkas',
    deleteTask: 'Hapus Tugas',
    deleteComment: 'Hapus Komentar',
    deleteCommentConfirmation: 'Komentar yang dihapus tidak dapat dikembalikan.',
    replyToAttachmentPlaceholder: 'Balas ke lampiran ini...',
    noAttachmentsSubmitted: 'Belum ada item checklist yang disubmit.',
    uploadedBy: 'Diupload oleh',
    noMatchingUsers: 'Tidak ada pengguna yang cocok',
    oldFile: 'Berkas lama:',
    tapToReplace: 'Ketuk untuk mengganti dokumen',
    usersSelected: 'Pengguna Dipilih',
    deleteConfirmation: 'Apakah Anda yakin ingin menghapus tugas ini? Tindakan ini tidak dapat dibatalkan.',
    awaitingReport: 'Menunggu laporan',
    reviewModal: {
      approveTitle: 'Setujui Tugas',
      rejectTitle: 'Tolak Tugas',
      incompleteTitle: 'Tandai Tidak Lengkap',
      completeTitle: 'Selesaikan Tugas',
      failedTitle: 'Gagalkan Tugas',
      score: 'Nilai (0-100)',
      enterScore: 'Masukkan nilai',
      addNotes: 'Tambahkan catatan tinjauan...',
    },
    buttons: {
      approve: 'Setujui',
      reject: 'Tolak',
      incomplete: 'Tidak Lengkap',
      complete: 'Selesai',
      failed: 'Gagal',
      submitReport: 'Buat Laporan',
      editDraft: 'Ubah Draf',
      startWork: 'Mulai Pekerjaan',
      pendingWork: 'Pending',
      review: 'Review',
    },
    addCommentPlaceholder: 'Berikan respon...',
    send: 'Kirim',
    client: 'Klien',
    vessel: 'Kapal',
    vesselHistory: 'Riwayat Tugas Kapal',
    noVesselTasks: 'Tidak ada tugas ditemukan untuk kapal ini.',
    file: 'Berkas',
    assignFailed: 'Gagal menugaskan pengguna',
    taskUpdated: 'Tugas berhasil diperbarui',
    taskUpdateFailed: 'Gagal memperbarui tugas',
    taskDeleted: 'Tugas berhasil dihapus',
    taskDeleteFailed: 'Gagal menghapus tugas',
    notAssignedError: 'Anda tidak terdaftar sebagai pekerja untuk tugas ini. Silakan tambahkan nama Anda di bagian "Ditugaskan Ke" terlebih dahulu.',
    waitingPreparation: 'Menunggu Persiapan',
    waitingPreparationMsg: 'Tugas belum bisa dimulai karena persiapan (Checklist/Notes) belum dilakukan oleh Pemeriksa.',
    notAuthorizedSubmit: 'Anda tidak berhak mengirimkan laporan untuk tugas ini karena Anda bukan pekerja yang ditugaskan.',
    checkerNotDoneMsg: 'Tugas belum bisa diselesaikan. Checker belum menyelesaikan proses pemeriksaan.',
    alerts: {
      approved: 'Tugas berhasil disetujui',
      rejected: 'Tugas berhasil ditolak',
      incompleted: 'Tugas ditandai tidak lengkap',
      started: 'Tugas berhasil dimulai',
      pendinged: 'Tugas ditunda sementara',
      cancelled: 'Tugas berhasil dibatalkan',
      actionFailed: 'Aksi gagal. Silakan coba lagi.',
    },
    cancelModal: {
      title: 'Batalkan Task',
      noteLabel: 'Alasan pembatalan (wajib diisi)',
      notePlaceholder: 'Contoh: Task tidak lagi diperlukan, digantikan task lain, dll...',
      noteRequired: 'Alasan pembatalan wajib diisi.',
      confirmBtn: 'Batalkan Task',
    },
    resumedNote: 'Pengerjaan task dimulai kembali',
    showReply: 'Balas',
    tabTesting: 'Testing',
    gpsTitle: 'Posisi & mesin kapal (GPS)',
    gpsUpdatedAt: 'Diperbarui {time}',
    gpsRefresh: 'Muat ulang',
    gpsLoadFailed: 'Gagal memuat posisi kapal',
    gpsMoving: 'Berlayar',
    gpsStopped: 'Berhenti',
    gpsSpeed: 'Kecepatan / arah',
    gpsPositionTime: 'Posisi terakhir',
    gpsCoordinates: 'Koordinat (buka di Maps)',
    gpsDevice: 'Perangkat',
    gpsMinutesAgo: '{n} menit lalu',
    gpsHoursAgo: '{n} jam lalu',
    gpsDaysAgo: '{n} hari lalu',
    gpsNoEngineData: 'Perangkat ini tidak mengirim data mesin',
    gpsEngineUpdated: 'Data mesin {time}',
    gpsStale: 'sudah lama tidak diperbarui',
    gpsRpmTitle: 'RPM Mesin',
    gpsEngineN: 'Engine {n}',
    gpsEngineRunning: 'Menyala',
    gpsEngineOff: 'Mati',
    gpsFuelTitle: 'Bahan bakar (konsumsi / flow / return)',
    gpsNoSerial: 'Serial Number belum terdaftar harap hubungi administrator',
    gpsNoApplicationId: 'Application ID belum terdaftar harap hubungi administrator',
    gpsDeviceNotRegistered: 'Device tidak terdaftar di application yang sesuai',
    gpsTokenInvalid: 'Token tidak berlaku',
    gpsAutoRefresh: 'Refresh otomatis tiap {n} detik',
  },
  taskSubmission: {
    title: 'Kirim Laporan',
    reportingFor: 'Melaporkan untuk Tugas:',
    describeWork: 'Jelaskan pekerjaan yang dilakukan...',
    addFiles: '+ Tambah Berkas',
    noFiles: 'Belum ada berkas ditambahkan.',
    locationAcquired: 'Lokasi didapatkan',
    fetchingLocation: 'Mengambil lokasi...',
    before: 'Sebelum',
    after: 'Sesudah',
    uploadScreen: {
      example: 'Contoh',
      imageExample: 'Contoh Gambar',
      yourFile: 'Berkas Anda',
      tapToUpload: 'Ketuk untuk unggah',
    },
    alerts: {
      progressSaved: 'Progres berhasil disimpan!',
      saveProgressFailed: 'Gagal menyimpan progres.',
      missingDescription: 'Mohon masukkan deskripsi',
      locationRequired: 'Lokasi wajib diisi. ',
      missingInformation: 'Mohon lengkapi kolom yang wajib: ',
      submissionSuccess: 'Laporan tugas berhasil dikirim!',
      submissionFailed: 'Gagal mengirim laporan. Silakan coba lagi.',
      offlineSaved: 'Laporan tersimpan offline dan akan dikirim saat terkoneksi.',
    },
  },
  taskList: {
    title: 'Daftar Tugas',
    searchPlaceholder: 'Cari tugas atau #ID...',
    new: 'BARU',
    update: 'UPDATE',
    loading: 'Memuat tugas...',
    noTasksFound: 'Tidak ada tugas yang ditemukan.',
    noTasksAvailable: 'Tidak ada tugas tersedia.',
    loadingMore: 'Memuat lebih banyak...',
    allDataLoaded: 'Semua tugas telah dimuat',
    overdue: 'Lewat Tenggat',
    newMessage: '💬 Pesan Baru',
  },
  personalData: {
    title: 'Data Pribadi',
    leaveBalance: 'Sisa Cuti',
    used: 'Terpakai',
    total: 'Total',
    remaining: 'Sisa',
    days: 'Hari',
    personalInfo: 'Informasi Pribadi',
    hrMenu: 'Menu Kepegawaian',
    attendance: 'Kehadiran',
    leave: 'Cuti',
    payslip: 'Slip Gaji',
    reimburse: 'Reimburse',
    email: 'Alamat Email',
    employeeId: 'ID Karyawan',
    joinDate: 'Tanggal Bergabung',
    phone: 'Nomor Telepon',
    department: 'Departemen',
    activeEmployee: 'Karyawan Aktif',
    uploadPhoto: 'Ketuk untuk upload foto',
    leaveRequest: 'Pengajuan Cuti',
    correctionRequest: 'Koreksi Absensi',
    loanRequest: 'Kasbon / Pinjaman',
    documents: 'Dokumen Saya',
    requestLeaveBtn: 'Ajukan Cuti',
    cancel: 'Batal',
    uploading: 'Mengunggah...',
    addDocument: 'Tambah Dokumen',
    averageScore: 'Nilai Rata-rata',
    pts: 'poin',
    vsLastMonth: 'vs bulan lalu',
    noScoreData: 'Belum ada data',
    tasks: 'tugas',
    businessCard: 'Kartu Nama',
    qrCode: 'Kode QR',
    showQr: 'Tampilkan QR',
    showCard: 'Lihat Kartu',
    tapToSeeIdCard: 'Ketuk untuk melihat Kartu ID ↺',
    idCard: 'KARTU ID',
    idNumber: 'Nomor ID',
    tapToSeeBusinessCard: 'Ketuk untuk melihat Kartu Nama ↺',
    employeeLabel: 'Karyawan',
    inbox: 'Kotak Masuk',
  },
  leaveHistory: {
    title: 'Daftar Pengajuan',
    requestList: 'Daftar Pengajuan',
    tabMine: 'Pengajuan Saya',
    tabTeam: 'Pengajuan Tim',
    allMonths: 'Semua Bulan',
    allYears: 'Semua Tahun',
    filterByName: 'Cari nama...',
    loading: 'Memuat data...',
    noData: 'Tidak ada pengajuan cuti.',
    loadingMore: 'Memuat data lainnya...',
    allDataLoaded: 'Semua data telah dimuat',
    hasAttachment: 'Lampiran',
    leaveBalance: 'Sisa Cuti',
    dates: 'Tanggal',
    duration: 'Lama Cuti',
    days: 'Hari',
    months: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'],
    status: {
      approved: 'Disetujui',
      rejected: 'Ditolak',
      pending: 'Menunggu',
      cancelled: 'Dibatalkan'
    }
  },
  documentHistory: {
    title: 'Dokumen Saya',
    tabAll: 'Semua',
    tabLeave: 'Cuti',
    tabCorrection: 'Koreksi',
    tabLoan: 'Kasbon',
    noData: 'Belum ada pengajuan.',
    loadMore: 'Muat lebih banyak',
    approved: 'Disetujui',
    rejected: 'Ditolak',
    pending: 'Menunggu',
    deleteConfirm: 'Yakin ingin membatalkan pengajuan ini? Tindakan ini tidak dapat dibatalkan.',
    confirmTitle: 'Konfirmasi',
    deleteBtn: 'Ya, Batalkan',
    deleteSuccess: 'Pengajuan berhasil dibatalkan.',
    deleteError: 'Gagal membatalkan pengajuan.',
    correctionTitle: 'Koreksi Absensi',
    loanTitle: 'Kasbon / Pinjaman',
    annualLeave: 'Cuti Tahunan',
    sickLeave: 'Sakit',
    unpaidLeave: 'Absen',
    maternityLeave: 'Melahirkan',
    marriageLeave: 'Menikah',
    months: 'bulan',
    weeks: 'minggu',
  },
  notification: {
    title: 'Notifikasi',
    markAllRead: 'Tandai semua dibaca',
    noNotifications: 'Belum ada notifikasi.',
    actionRequired: 'Perlu Aksi',
    noActionRequired: 'Tidak ada notifikasi yang perlu ditindaklanjuti',
    actionTag: 'Aksi',
  },
  correctionDetail: {
    title: 'Detail Koreksi Absensi',
    currentStatus: 'Status Pengajuan',
    attendanceInfo: 'Data Absensi yang Dikoreksi',
    date: 'Tanggal',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    breakOut: 'Mulai Istirahat',
    breakIn: 'Selesai Istirahat',
    reason: 'Alasan Koreksi',
    evidence: 'Bukti / Foto',
    reviewInfo: 'Info Review',
    reviewedBy: 'Direview oleh',
    rejectReason: 'Alasan Penolakan',
    submittedAt: 'Diajukan',
    approved: 'Disetujui',
    rejected: 'Ditolak',
    pending: 'Menunggu',
    cancelBtn: 'Batalkan Pengajuan',
    confirmTitle: 'Konfirmasi',
    cancelConfirm: 'Yakin ingin membatalkan pengajuan koreksi absensi ini?',
    cancelSuccess: 'Pengajuan koreksi berhasil dibatalkan.',
    cancelError: 'Gagal membatalkan pengajuan.',
  },
  loanDetail: {
    title: 'Detail Kasbon / Pinjaman',
    currentStatus: 'Status Pengajuan',
    loanInfo: 'Detail Pinjaman',
    amount: 'Jumlah Pinjaman',
    tenor: 'Tenor',
    months: 'Bulan',
    weeks: 'Minggu',
    reason: 'Alasan Pengajuan',
    adminNote: 'Catatan Admin',
    submittedAt: 'Diajukan',
    updatedAt: 'Diperbarui',
    approved: 'Disetujui',
    rejected: 'Ditolak',
    pending: 'Menunggu',
    cancelBtn: 'Batalkan Pengajuan',
    cancelBtnConfirm: 'Ya, Batalkan',
    confirmTitle: 'Konfirmasi',
    cancelConfirm: 'Yakin ingin membatalkan pengajuan kasbon ini?',
    cancelSuccess: 'Pengajuan kasbon berhasil dibatalkan.',
    cancelError: 'Gagal membatalkan pengajuan.',
    requested: 'diminta',
  },
  loanRequest: {
    title: 'Pengajuan Kasbon',
    amount: 'Jumlah Pinjaman (Rp)',
    amountPlaceholder: 'Contoh: 5000000',
    tenor: 'Tenor',
    tenorPlaceholder: 'Contoh: 3',
    months: 'Bulan',
    weeks: 'Minggu',
    reason: 'Alasan Pengajuan',
    reasonPlaceholder: 'Jelaskan keperluan pengajuan kasbon...',
    submit: 'Ajukan Kasbon',
    submitting: 'Mengajukan...',
    success: 'Pengajuan kasbon berhasil dikirim!',
    error: 'Gagal mengirim pengajuan.',
    validation: 'Mohon lengkapi jumlah pinjaman dan tenor.',
  },
  leaveRequest: {
    title: 'Pengajuan Cuti',
    leaveType: 'Tipe Cuti',
    annualLeave: 'Cuti Tahunan',
    sickLeave: 'Sakit',
    unpaidLeave: 'Absen',
    maternityLeave: 'Melahirkan',
    marriageLeave: 'Menikah',
    dates: 'Tanggal',
    startDate: 'Tanggal Mulai',
    endDate: 'Tanggal Selesai',
    reason: 'Alasan',
    reasonPlaceholder: 'Alasan pengajuan cuti...',
    submit: 'Ajukan Cuti',
    submitting: 'Mengajukan...',
    success: 'Pengajuan cuti berhasil dibuat!',
    error: 'Gagal membuat pengajuan cuti.',
    validation: 'Mohon lengkapi semua kolom wajib (Tipe cuti, tanggal mulai, tanggal selesai, alasan).',
    attachment: 'Lampiran (Opsional)',
    tapToUpload: 'Ketuk untuk unggah dokumen'
  },
  leaveDetails: {
    title: 'Detail Pengajuan',
    notFound: 'Data cuti tidak ditemukan',
    successWithdraw: 'Pengajuan berhasil ditarik/dihapus',
    successApproved: 'Cuti berhasil disetujui',
    successRejected: 'Cuti berhasil ditolak',
    errorAction: 'Terjadi kesalahan. Silakan coba lagi.',
    currentStatus: 'Status Saat Ini',
    status: {
      approved: 'Disetujui',
      rejected: 'Ditolak',
      pending: 'Menunggu Persetujuan',
      cancelled: 'Dibatalkan'
    },
    modal: {
      cancelTitle: 'Batalkan Pengajuan',
      cancelMsg: 'Yakin ingin membatalkan pengajuan cuti ini?',
      cancelBtn: 'Batalkan',
      approveTitle: 'Setujui Pengajuan',
      approveMsg: 'Yakin ingin menyetujui pengajuan cuti ini?',
      approveBtn: 'Setujui',
      rejectTitle: 'Tolak Pengajuan',
      rejectMsg: 'Yakin ingin menolak pengajuan cuti ini?',
      rejectBtn: 'Tolak'
    },
    leaveInfo: 'Informasi Cuti',
    leaveType: 'Tipe Cuti',
    dates: 'Tanggal',
    leaveBalance: 'Sisa Cuti',
    duration: 'Lama Cuti',
    days: 'Hari',
    reason: 'Alasan Cuti',
    submittedBy: 'Diajukan Oleh',
    attachmentAvailable: 'Lampiran Tersedia',
    view: 'Lihat',
    createdAt: 'Dibuat pada',
    processing: 'Memproses...',
    approvedBy: 'Disetujui oleh',
    rejectedBy: 'Ditolak oleh',
  },
  activity: {
    title: 'Aktivitas',
    survey: 'Survei',
    meeting: 'Meeting',
    marketing: 'Marketing',
    recent: 'Aktivitas Terbaru',
    createTitle: 'Buat Aktivitas',
    validation: {
      fillRequired: 'Judul dan Tanggal Waktu wajib diisi.'
    },
    alerts: {
      success: 'Aktivitas berhasil dibuat!',
      failed: 'Gagal membuat aktivitas. Silakan coba lagi.'
    },
    titlePlaceholder: 'Masukkan judul aktivitas',
    datetimePlaceholder: 'Pilih Tanggal dan Waktu',
    locationPlaceholder: 'Contoh: Ruang Meeting A / Site Client',
    addressPlaceholder: 'Alamat lengkap (opsional)',
    tapToUpload: 'Ketuk untuk mengunggah lampiran',
    descriptionPlaceholder: 'Tuliskan deskripsi aktivitas secara detail...',
    deleteTitle: 'Hapus Aktivitas',
    deleteConfirm: 'Apakah Anda yakin ingin menghapus aktivitas ini?',
    noActivities: 'Tidak ada aktivitas.',
    loadingMore: 'Memuat lebih banyak...',
    allLoaded: 'Semua aktivitas telah dimuat',
    justNow: 'Baru saja',
    minsAgo: 'menit yang lalu',
    hoursAgo: 'jam yang lalu',
    daysAgo: 'hari yang lalu',
    monthsAgo: 'bulan yang lalu',
    yearsAgo: 'tahun yang lalu'
  },
  attendance: {
    title: 'Kehadiran',
    checkIn: 'Check In',
    checkOut: 'Check Out',
    breakOut: 'Mulai Istirahat',
    breakIn: 'Selesai Istirahat',
    history: 'Riwayat Kehadiran',
    checkInTime: 'Waktu Masuk',
    checkOutTime: 'Waktu Keluar',
    breakOutTime: 'Keluar Istirahat',
    breakInTime: 'Masuk Istirahat',
    status: 'Status',
    noData: 'Tidak ada riwayat kehadiran.',
    successCheckIn: 'Berhasil Check In!',
    successCheckOut: 'Berhasil Check Out!',
    successBreakOut: 'Berhasil Mulai Istirahat!',
    successBreakIn: 'Berhasil Selesai Istirahat!',
    takePhoto: 'Ambil Foto',
    present: 'Hadir',
    fetchingLocation: 'Mendapatkan lokasi...',
    addressNotFound: 'Alamat tidak ditemukan',
    notePlaceholder: 'Catatan (Opsional)...',
    noBreakIn: 'Tidak mengakhiri istirahat',
    noBreakOut: 'Tidak mengambil istirahat',
    validation: {
      photoRequired: 'Mohon ambil foto (bukti kehadiran).'
    },
    alerts: {
      locationNotAcquired: 'Lokasi belum didapatkan. Pastikan GPS aktif.',
      outOfRange: 'Anda berada di luar batas area absensi.',
      alreadyCompleted: 'Anda sudah menyelesaikan absensi hari ini!',
      locationError: 'Gagal mendapatkan lokasi. Pastikan GPS aktif dan izinkan akses.',
      noGeolocation: 'Geolokasi tidak didukung oleh browser ini.'
    },
    offlineSaved: 'Absensi tersimpan offline dan akan dikirim saat terkoneksi.',
    prevDayWarning: 'Ada absensi belum selesai pada',
    prevDayCheckoutFirst: 'Silakan checkout terlebih dahulu untuk dapat check in hari ini.',
    businessTrip: 'Perjalanan Dinas (Luar Kantor)',
    businessTripApproved: 'Dinas Disetujui',
    businessTripRejected: 'Dinas Ditolak',
    businessTripPending: 'Dinas Menunggu Approval',
    cancelledByLeave: 'Absensi ini dibatalkan karena ada izin/cuti yang disetujui.',
    hrNoteTitle: 'Catatan HR',
    hrNoteBy: 'Oleh',
    hrNoteTodayDesc: 'HR sudah mencatat absensi Anda untuk hari ini, jadi Anda tidak perlu check-in.',
    correction: {
      title: 'Ajukan Koreksi Absensi',
      dateLabel: 'Tanggal',
      checkInLabel: 'Waktu Masuk',
      checkOutLabel: 'Waktu Keluar',
      breakOutLabel: 'Keluar Istirahat',
      breakInLabel: 'Masuk Istirahat',
      reasonLabel: 'Alasan',
      reasonPlaceholder: 'Jelaskan alasan koreksi absensi...',
      evidenceLabel: 'Bukti Foto',
      evidenceButton: 'Pilih Foto',
      submit: 'Ajukan Koreksi',
      submitSuccess: 'Permintaan koreksi berhasil diajukan!',
      sectionTitle: 'Permintaan Koreksi',
      pending: 'Menunggu',
      approved: 'Disetujui',
      rejected: 'Ditolak',
      rejectedReason: 'Alasan Penolakan',
      optional: 'Opsional',
      cancelRequest: 'Batalkan Pengajuan',
      cancelConfirm: 'Apakah Anda yakin ingin membatalkan permintaan koreksi ini?',
      validation: {
        required: 'Tanggal dan alasan wajib diisi.'
      }
    }
  },
  notFound: {
    title: 'Halaman Tidak Ditemukan',
    description: 'Oops! Halaman yang Anda cari tidak ada atau telah dipindahkan.',
    backToHome: 'Kembali ke Beranda'
  },
  marketingActivity: {
    title: 'Aktivitas Marketing',
    createTitle: 'Buat Aktivitas Marketing',
    type: 'Tipe Aktivitas',
    selectType: 'Pilih Tipe Aktivitas',
    companyName: 'Nama Perusahaan',
    enterCompany: 'Masukkan nama perusahaan',
    subject: 'Subjek',
    enterSubject: 'Masukkan subjek',
    dateAndTime: 'Tanggal & Waktu',
    description: 'Deskripsi',
    descriptionPlaceholder: 'Tuliskan deskripsi lengkap...',
    location: 'Lokasi',
    submit: 'Submit Aktivitas',
    validation: {
      fillRequired: 'Tanggal, Tipe Aktivitas, Nama Perusahaan, dan Subjek wajib diisi.'
    },
    alerts: {
      success: 'Aktivitas marketing berhasil dibuat!',
      failed: 'Gagal membuat aktivitas. Silakan coba lagi.'
    },
    waitingLocation: 'Harap tunggu, sedang mendapatkan koordinat lokasi...',
    activityInfo: 'Info Aktivitas',
    detailTitle: 'Detail Aktivitas',
    loading: 'Memuat detail...',
    notFound: 'Aktivitas tidak ditemukan.',
    noAddress: 'Tidak ada alamat',
    participants: 'Partisipan',
    minutesTitle: 'Notulensi',
    noActivities: 'Belum Ada Aktivitas',
    noActivitiesDesc: 'Anda belum membuat aktivitas marketing apa pun.',
    add: 'Tambah',
    participantName: 'Nama Partisipan',
    position: 'Posisi / Jabatan',
    noParticipants: 'Belum ada partisipan yang ditambahkan.',
    signed: 'Tertanda',
    sign: 'Tanda Tangan',
    issue: 'Isu / Topik *',
    date: 'Tanggal',
    status: 'Status',
    selectStatus: 'Pilih Status',
    action: 'Tindakan (Action)',
    department: 'Departemen',
    pic: 'PIC',
    target: 'Target',
    noMinutes: 'Belum ada notulensi.',
    added: 'Ditambahkan:',
    participantSignature: 'Tanda Tangan Partisipan',
    clear: 'Hapus',
    saveSignature: 'Simpan TTD',
    signaturePreview: 'Pratinjau Tanda Tangan',
    documentation: 'Dokumentasi',
    addDocumentation: 'Tambah Dokumentasi',
    noDocumentation: 'Belum ada dokumentasi yang ditambahkan.',
    deleteParticipantTitle: 'Hapus Partisipan',
    deleteParticipantConfirm: 'Apakah Anda yakin ingin menghapus partisipan ini?',
    deleteMinuteTitle: 'Hapus Notulensi',
    deleteMinuteConfirm: 'Apakah Anda yakin ingin menghapus notulensi ini?',
    deleteDocumentationTitle: 'Hapus Dokumentasi',
    deleteDocumentationConfirm: 'Apakah Anda yakin ingin menghapus dokumen ini?',
    deleteActivityTitle: 'Hapus Aktivitas',
    deleteActivityConfirm: 'Apakah Anda yakin ingin menghapus aktivitas marketing ini secara permanen?'
  },
  eventActivity: {
    title: 'Event Activity',
    menuLabel: 'Event',
    createTitle: 'Buat Event Activity',
    detailTitle: 'Detail Event',
    date: 'Tanggal',
    description: 'Keterangan',
    descriptionPlaceholder: 'Deskripsikan acara ini...',
    location: 'Lokasi',
    photos: 'Foto',
    addPhotos: 'Tambah Foto',
    participants: 'Peserta Event',
    participantName: 'Nama Peserta',
    position: 'Jabatan / Peran',
    add: 'Tambah',
    noParticipants: 'Belum ada peserta yang ditambahkan.',
    noActivities: 'Belum Ada Event',
    noActivitiesDesc: 'Anda belum membuat event apapun.',
    loading: 'Memuat event...',
    loadingMore: 'Memuat lebih banyak...',
    allLoaded: 'Semua event telah dimuat',
    submit: 'Buat Event',
    saving: 'Menyimpan...',
    waitingLocation: 'Harap tunggu, sedang mendapatkan koordinat lokasi...',
    alerts: {
      success: 'Event activity berhasil dibuat!',
      failed: 'Gagal membuat event. Silakan coba lagi.'
    },
    validation: {
      fillRequired: 'Tanggal wajib diisi.'
    },
    deleteTitle: 'Hapus Event',
    deleteConfirm: 'Apakah Anda yakin ingin menghapus event ini?',
    deleteParticipantTitle: 'Hapus Peserta',
    deleteParticipantConfirm: 'Apakah Anda yakin ingin menghapus peserta ini?',
    participants_count: 'Peserta',
    photoCount: 'foto',
    creator: 'Dibuat oleh',
    noPhotos: 'Belum ada foto yang diunggah.',
    expandImage: 'Lihat Foto',
    searchUser: 'Cari pengguna aplikasi...',
    noUsersFound: 'Pengguna tidak ditemukan',
    dateTime: 'Tanggal & Waktu'
  },
  checkerTask: {
    preparationTitle: 'Persiapan Pemeriksaan',
    inspectionTitle: 'Pemeriksaan Tugas',
    checkerChecklist: 'Checklist Pemeriksa',
    searchChecklist: 'Cari checklist pemeriksa...',
    preparationNotesTitle: 'Catatan Persiapan (Notes)',
    inspectionNotesTitle: 'Catatan Pemeriksaan (Notes)',
    addPreparationNotes: 'Tambahkan catatan persiapan...',
    addInspectionNotes: 'Tambahkan catatan pemeriksaan...',
    savePreparation: 'Simpan (Persiapan)',
    saveInspection: 'Simpan (Pemeriksaan)',
    submitPreparation: 'Submit (Persiapan)',
    submitInspection: 'Submit (Pemeriksaan)',
    failedToSave: 'Gagal menyimpan ',
    statusChecked: 'Sudah Diperiksa',
    statusPrepared: 'Sudah Disiapkan',
    statusNotPrepared: 'Belum Disiapkan',
    statusPending: 'Item Kurang',
    noChecklistItems: 'Belum ada item checklist pemeriksaan.',
    noChecklistSetup: 'Data checklist belum ada. Silakan tambahkan checklist pemeriksa terlebih dahulu.',
    btnPreparation: 'Persiapan',
    btnInspection: 'Pemeriksaan',
    addChecklistTitle: 'Tambah Checklist Pemeriksa',
    addChecklistPlaceholder: 'Contoh: Helm Safety, Kunci Inggris...',
    addChecklistCategoryLabel: 'Kategori',
    addChecklistCategoryPlaceholder: 'Tanpa kategori',
    categoryTools: 'Tools',
    categoryInstallationItems: 'Installation Items',
    categoryConsumables: 'Consumables',
    preparedAt: 'Disiapkan pada',
    checkedAt: 'Diperiksa pada',
    preparationNote: 'Catatan Persiapan:',
    checkerNote: 'Catatan Pemeriksa:',
    pendingItemsTitle: 'Item berikut perlu dilengkapi:',
    btnConfirmReplacement: 'Konfirmasi Item Pengganti',
    confirmReplacementTitle: 'Konfirmasi Item Pengganti',
    missingItemsLabel: 'Item yang perlu dilengkapi:',
    replacementNoteLabel: 'Keterangan penggantian item',
    replacementNotePlaceholder: 'Jelaskan item pengganti yang sudah disediakan...',
    photoEvidenceLabel: 'Foto bukti (opsional, maks. 5)',
    btnSubmitConfirmation: 'Kirim Konfirmasi',
    btnSubmitting: 'Mengirim...',
    confirmSuccess: 'Konfirmasi berhasil dikirim. Checker akan segera memeriksa kembali.',
    confirmFailed: 'Gagal mengirim konfirmasi',
    itemMissingSuffix: '— kurang',
    checkerRole: 'Pemeriksa',
    checklistSaved: 'Checklist pemeriksa berhasil disimpan',
    checklistSaveFailed: 'Gagal menyimpan checklist pemeriksa',
    checklistAddFailed: 'Gagal menambah checklist pemeriksa',
    replacementSubmittedTitle: 'Item Pengganti Telah Disubmit',
    replacementNoteLabel2: 'Keterangan:',
    replacementPhotosLabel: 'Foto Bukti:',
    btnConfirmAccept: 'Terima Item Pengganti',
    replacementAccepted: 'Item pengganti berhasil dikonfirmasi. Status checker berubah menjadi checked.',
    replacementAcceptFailed: 'Gagal mengkonfirmasi item pengganti',
    waitingUserResponse: 'Menunggu konfirmasi item pengganti dari pekerja',
    itemAcceptedNotif: 'Item diterima',
    selectedItems: 'Item yang Diceklis',
    preparedItemsTitle: 'Item Persiapan',
    checkedItemsTitle: 'Item Pemeriksaan',
    items: 'item',
    itemMissingBadge: 'Hilang',
    itemInstalledBadge: 'Terpasang',
    itemConsumedBadge: 'Terpakai',
    itemReturnBadge: 'Dikembalikan',
    itemNotInspectedBadge: 'Belum Dicek',
    btnPreparedItems: 'Item Persiapan',
    btnCheckedItems: 'Item Pemeriksaan',
    btnEditPreparation: 'Edit Persiapan',
    btnCancelPreparation: 'Batalkan Persiapan',
    cancelPreparationSuccess: 'Persiapan berhasil dibatalkan.',
    cancelPreparationFailed: 'Gagal membatalkan persiapan.',
    selfInspectionTitle: 'Inspeksi Mandiri',
    selfInspectionNotesTitle: 'Catatan Inspeksi Mandiri (Notes)',
    addSelfInspectionNotes: 'Tambahkan catatan inspeksi mandiri...',
    saveSelfInspection: 'Simpan (Inspeksi Mandiri)',
    submitSelfInspection: 'Submit (Inspeksi Mandiri)',
    btnSelfInspection: 'Inspeksi Mandiri',
    selfCheckMissingTitle: 'Item berikut belum ditemukan saat inspeksi mandiri:',
    waitingSelfInspection: 'Menunggu inspeksi mandiri dari pekerja sebelum pemeriksaan dapat dilakukan.',
    btnSelfCheckedItems: 'Item Inspeksi Mandiri',
    selfCheckedItemsTitle: 'Item Inspeksi Mandiri',
    selfCheckReferenceNote: 'Checklist di bawah sudah diisi otomatis sesuai hasil inspeksi mandiri pekerja. Sesuaikan dengan kondisi fisik yang Anda lihat langsung.',
    qtyLessThanPrepared: 'Kurang {diff} dari jumlah saat persiapan ({prepared}).',
    qtyMoreThanPrepared: 'Lebih {diff} dari jumlah saat persiapan ({prepared}).',
    serialPlaceholder: 'Serial number (pisahkan dengan koma)',
  },
  preCheckReport: {
    title: 'Pre-Check Reports',
    titleCreate: 'Buat Pre-Check Report',
    titleEdit: 'Edit Pre-Check Report',
    create: 'Buat',
    loading: 'Memuat...',
    saving: 'Menyimpan...',
    empty: 'Belum ada pre-check report.',
    createFirst: 'Buat Laporan Pertama',
    typeLabel: 'Tipe Laporan',
    typePreparation: 'Persiapan',
    typeInspection: 'Pemeriksaan',
    dateLabel: 'Tanggal',
    checklistLabel: 'Item Checklist',
    addItem: 'Tambah',
    addItemTitle: 'Tambah Item Checklist',
    addItemPlaceholder: 'Contoh: Helm Safety, Kunci Inggris...',
    addItemCategoryLabel: 'Kategori',
    addItemCategoryPlaceholder: 'Tanpa kategori',
    addItemFailed: 'Gagal menambah item',
    searchPlaceholder: 'Cari item checklist...',
    noItems: 'Tidak ada item ditemukan.',
    qty: 'Qty',
    serialNumber: 'Nomor Seri',
    itemChecked: 'Item sudah dicek/tersedia',
    selectedItems: 'Item yang Dipilih',
    noteLabel: 'Catatan',
    notePlaceholder: 'Tambahkan catatan...',
    saveDraft: 'Simpan Draft',
    markReady: 'Tandai Siap',
    saveFailed: 'Gagal menyimpan laporan',
    statusDraft: 'Draft',
    statusReady: 'Siap',
    items: 'item checklist',
    linkedTask: 'Dilampirkan ke',
    btnView: 'Lihat / Edit',
    btnDelete: 'Hapus',
    deleteConfirm: 'Hapus laporan ini?',
    deleteFailed: 'Gagal menghapus laporan',
    btnLink: 'Lampirkan Pre-Check Report',
    linkedReportTitle: 'Pre-Check Report Dilampirkan',
    linkSuccess: 'Laporan berhasil dilampirkan ke task.',
    linkFailed: 'Gagal melampirkan laporan.',
    sheetTitle: 'Pilih Pre-Check Report',
    sheetDesc: 'Hanya laporan berstatus "Siap" yang ditampilkan',
    noAvailable: 'Tidak ada pre-check report yang tersedia.',
    noAvailableHint: 'Buat laporan baru dan tandai sebagai "Siap" terlebih dahulu.',
    btnSelect: 'Pilih Laporan Ini',
    btnSelected: 'Terpilih',
    btnUnlink: 'Batal Lampiran',
    btnChange: 'Ganti Dokumen',
    unlinkSuccess: 'Lampiran dibatalkan.',
    unlinkFailed: 'Gagal membatalkan lampiran.',
    vesselLabel: 'Kapal (opsional)',
    vesselPlaceholder: 'Pilih kapal...',
    searchVessel: 'Cari kapal...',
    clearVessel: 'Hapus pilihan',
  },
  schedule: {
    title: 'Jadwal',
    fetchError: 'Gagal mengambil jadwal tugas'
  },
  inbox: {
    title: 'Kotak Masuk',
    searchPlaceholder: 'Cari pesan...',
    allMessages: 'Semua Pesan',
    unreadMessages: 'Belum Dibaca',
    noMessages: 'Tidak ada pesan',
    emptyInbox: 'Kotak masuk Anda saat ini kosong.'
  },
  payslip: {
    title: 'Slip Gaji',
    slipsAvailable: 'slip tersedia',
    noSlipYet: 'Belum ada slip',
    thisMonth: 'BULAN INI',
    period: 'Periode',
    view: 'Lihat',
    download: 'Unduh',
    loadFailed: 'Gagal Memuat',
    retry: 'Coba Lagi',
    noSlipTitle: 'Belum Ada Slip',
    noSlipDesc: 'Slip gaji Anda akan muncul di sini setelah diproses oleh HR.',
    viewAll: 'Lihat semua →',
    last3Months: '3 Bulan Terakhir',
    allOf: 'Semua –',
    noSlipForYear: 'Tidak ada slip untuk tahun',
    moreSlips: 'slip lainnya di',
    modalTitlePrefix: 'Slip Gaji –',
    viewError: 'Gagal membuka slip. Coba lagi.',
    downloadError: 'Gagal mengunduh slip. Coba lagi.',
    fetchError: 'Gagal memuat data slip gaji.',
    monthsShort: ['JAN', 'FEB', 'MAR', 'APR', 'MEI', 'JUN', 'JUL', 'AGS', 'SEP', 'OKT', 'NOV', 'DES'],
  },
  surveyActivity: {
    detail: 'Detail Survey',
    notFound: 'Survey activity tidak ditemukan.',
    findings: 'Temuan Survey',
    notes: 'Catatan',
    photos: 'Foto',
    respondents: 'responden',
    deleteTitle: 'Hapus Survey?',
    deleteDesc: 'Survey activity ini dan semua fotonya akan dihapus permanen.',
    noLocationName: 'Survey Activity',
    checklistSection: 'Survey Checklist',
    checklistSearch: 'Cari checklist...',
    checklistNoResult: 'Tidak ada checklist yang cocok.',
    checklistEmpty: 'Belum ada checklist yang ditambahkan.',
    checklistAdd: 'Tambah',
    checklistAddManual: 'Tambah Manual',
    checklistManualPlaceholder: 'Nama item checklist...',
    checklistNote: 'Catatan...',
    checklistValue: 'Nilai / Keterangan...',
    checklistPhotoNote: 'Keterangan foto...',
    checklistOther: 'Lainnya',
    checklistOtherPlaceholder: 'Masukkan nilai...',
    checklistSelectPlaceholder: '— Pilih —',
    checklistUploadPhoto: 'Upload Foto',
    checklistChangePhoto: 'Ganti Foto',
    statusDraft: 'Draft',
    statusActive: 'Link Dibagikan',
    statusSubmitted: 'Sudah Disubmit',
    submitBtn: 'Submit Survey',
    submitConfirmTitle: 'Submit Survey?',
    submitConfirmDesc: 'Setelah disubmit, survey tidak bisa diedit lagi. Yakin?',
    shareBtn: 'Bagikan Link',
    shareTitle: 'Bagikan Survey',
    shareExpiryLabel: 'Masa Berlaku Link',
    shareNoExpiry: 'Tanpa Batas',
    share1Day: '1 Hari',
    share3Days: '3 Hari',
    share7Days: '7 Hari',
    share30Days: '30 Hari',
    shareGenerate: 'Buat Link',
    shareRenew: 'Perbarui Link',
    shareCopy: 'Salin',
    shareCopied: 'Disalin!',
    shareLinkLabel: 'Link Publik',
    shareExpiresAt: 'Berlaku hingga',
    submittedBy: 'Disubmit oleh',
    submittedAt: 'Waktu submit',
    submittedLocation: 'Lokasi',
    submittedAnonymous: 'Disubmit via link publik',
  },
  publicSurvey: {
    title: 'Formulir Survey',
    expired: 'Link survey ini sudah kedaluwarsa.',
    notFound: 'Survey tidak ditemukan.',
    alreadySubmitted: 'Survey ini sudah disubmit.',
    inactive: 'Link survey ini tidak aktif.',
    nameLabel: 'Nama Lengkap',
    namePlaceholder: 'Masukkan nama lengkap Anda',
    contactLabel: 'Telepon / Email',
    contactPlaceholder: 'Masukkan nomor HP atau email',
    checklistSection: 'Survey Checklist',
    submitBtn: 'Submit Survey',
    submitting: 'Mengirim...',
    successTitle: 'Terima Kasih!',
    successDesc: 'Jawaban survey Anda telah berhasil dikirim.',
    capturingLocation: 'Mengambil lokasi Anda...',
    locationLabel: 'Lokasi Anda',
    nameRequired: 'Mohon masukkan nama Anda.',
    contactRequired: 'Mohon masukkan nomor HP atau email Anda.',
  },
  taskReview: {
    title: 'Review Checklist',
    taskDescription: 'Deskripsi Task',
    taskNotFound: 'Task tidak ditemukan',
    startedWorkAt: 'Mulai Pekerjaan',
    submittedReportAt: 'Submit Laporan',
    processingTime: 'Total Waktu Pemrosesan',
    targetDuration: 'Target Durasi',
    suggestedScore: 'Skor Saran',
    photosApproved: 'foto disetujui',
    finalScore: 'Skor Akhir',
    reviewerNotePlaceholder: 'Catatan reviewer (opsional)...',
    additionalAttachments: 'Lampiran Tambahan',
    overallNotes: 'Catatan Keseluruhan',
    overallNotesPlaceholder: 'Catatan review keseluruhan (opsional)...',
    reject: 'Tolak',
    complete: 'Selesai',
    confirmTitle: 'Selesaikan Task?',
    confirmDesc: 'Task ini akan ditandai selesai dengan skor berikut:',
    failedLoad: 'Gagal memuat data review',
    failedSubmit: 'Gagal mengirim review',
    errorModalTitle: 'Terjadi Kesalahan',
    showErrorDetails: 'Lihat detail error',
    hideErrorDetails: 'Sembunyikan detail error',
    view: 'Lihat',
    download: 'Unduh',
    rejectTitle: 'Tolak Task?',
    rejectDesc: 'Tambahkan catatan untuk assignee (opsional).',
    incompleteTitle: 'Tandai Incomplete?',
    incompleteDesc: 'Task ini akan ditutup permanen dan tidak dapat disubmit ulang. Harap berikan alasan.',
    incompleteReasonPlaceholder: 'Alasan (wajib diisi)...',
    incompleteReasonRequired: 'Harap berikan alasan sebelum menandai task sebagai incomplete.',
    incomplete: 'Incomplete',
  },
  travelExpenses: {
    title: 'Pengajuan Uang Jalan',
    addTitle: 'Pengajuan Uang Jalan',
    from: 'Berangkat Dari',
    to: 'Tujuan Ke',
    departure: 'Tanggal Berangkat',
    returnDate: 'Tanggal Kembali',
    costItems: 'Rincian Biaya',
    costType: 'Jenis Biaya',
    amount: 'Nominal',
    addRow: 'Tambah Baris',
    submit: 'Ajukan',
    editTitle: 'Edit Pengajuan Uang Jalan',
    saveDraft: 'Simpan Draft',
    draftNotice: 'Draft — belum diajukan untuk persetujuan.',
    errorRequired: 'Semua field wajib diisi',
    errorItems: 'Tambahkan minimal 1 rincian biaya',
    errorTask: 'Task tidak ditemukan',
    errorSave: 'Gagal menyimpan pengajuan',
  },
  travelExpenseRecap: {
    addTitle: 'Rekapan Biaya Perjalanan',
    editTitle: 'Edit Rekapan Biaya',
    sectionTitle: 'Rekapan Biaya Perjalanan',
    tripInfo: 'Informasi Perjalanan',
    from: 'Berangkat Dari',
    fromPlaceholder: 'Kota asal',
    to: 'Tujuan Ke',
    toPlaceholder: 'Kota tujuan',
    departure: 'Tanggal Berangkat',
    returnDate: 'Tanggal Kembali',
    costItems: 'Rincian Biaya',
    description: 'Deskripsi Biaya',
    descriptionPlaceholder: 'Contoh: Maxim dari bandara ke kapal',
    date: 'Tanggal',
    amount: 'Nominal (Rp)',
    notes: 'Notes (opsional)',
    notesPlaceholder: 'Mis: nama teknisi, keterangan tambahan',
    photoLabel: 'Foto Bukti / struk (opsional)',
    photoHint: 'Upload foto struk atau bukti pembayaran',
    photoTapHint: 'Tap foto untuk perbesar',
    colNotes: 'Catatan',
    colReceipt: 'Bukti',
    layoutTable: 'Tampilan tabel',
    layoutCard: 'Tampilan kartu',
    addRow: 'Tambah Baris',
    totalLabel: 'Total Pengeluaran',
    saveDraft: 'Simpan Draft',
    submit: 'Kirim',
    draftNotice: 'Draft — belum dikirim untuk review. Klik "Kirim" jika sudah selesai.',
    errorHeader: 'Semua field informasi perjalanan wajib diisi',
    errorItems: 'Tambahkan minimal 1 rincian biaya yang lengkap (deskripsi, tanggal, nominal)',
    errorTask: 'Task tidak ditemukan',
    errorSave: 'Gagal menyimpan rekapan',
    createdBy: 'Dibuat oleh',
    total: 'Total',
  },
  timeSheet: {
    menuTitle: 'Time Sheet',
    rows: 'baris',
    addTitle: 'Laporan Pekerjaan',
    editTitle: 'Edit Laporan Pekerjaan',
    saveChanges: 'Simpan Perubahan',
    vessel: 'Nama Kapal',
    technician: 'Nama Teknisi',
    location: 'Lokasi',
    locationPlaceholder: 'Contoh: Dermaga Utara',
    workItems: 'Rincian Pekerjaan',
    date: 'Tanggal',
    description: 'Deskripsi Pekerjaan',
    descriptionPlaceholder: 'Contoh: Analisa kerusakan sensor',
    addRow: 'Tambah Baris',
    submit: 'Kirim',
    errorLocation: 'Lokasi wajib diisi',
    errorItems: 'Tambahkan minimal 1 baris pekerjaan yang lengkap (tanggal & deskripsi)',
    errorTask: 'Task tidak ditemukan',
    errorSave: 'Gagal menyimpan time sheet',
    errorTechnician: 'Pilih minimal 1 teknisi',
    technicianUsed: 'Sudah ada time sheet',
    getLocation: 'Ambil Lokasi GPS',
    fetchingLocation: 'Mengambil lokasi...',
    apply: 'Gunakan',
    locationFetchError: 'Gagal mengambil lokasi. Pastikan GPS aktif dan izin lokasi diberikan.',
  },
  contacts: {
    title: 'Kontak',
    searchPlaceholder: 'Cari pengguna...',
    noUsersFound: 'Tidak ada pengguna ditemukan',
    calling: 'Memanggil...',
    micPermissionDenied: 'Izin mikrofon diperlukan untuk melakukan panggilan',
    micAccessFailed: 'Gagal mengakses mikrofon. Silakan coba lagi sesaat.',
    contactsTab: 'Kontak',
    chatsTab: 'Chat',
  },
  chat: {
    listTitle: 'Chat',
    noConversations: 'Belum ada percakapan',
    searchChatsPlaceholder: 'Cari nama atau pesan...',
    noResults: 'Tidak ditemukan',
    newChat: 'Chat Baru',
    newGroup: 'Grup Baru',
    newMessage: 'Pesan Baru',
    groupNamePlaceholder: 'Nama grup',
    selectMembers: 'Pilih Anggota',
    createGroup: 'Buat Grup',
    membersSelected: 'anggota dipilih',
    errorGroupName: 'Nama grup wajib diisi',
    errorSelectMembers: 'Pilih minimal 1 anggota',
    messagePlaceholder: 'Tulis pesan...',
    searchPlaceholder: 'Cari pengguna...',
    send: 'Kirim',
    attachFile: 'Lampirkan File',
    attachmentTooLarge: 'Ukuran file maksimal 7MB',
    attachmentTypeNotAllowed: 'Tipe file tidak didukung',
    errorSend: 'Gagal mengirim pesan',
    errorLoad: 'Gagal memuat percakapan',
    participants: 'Anggota',
    addParticipants: 'Tambah Anggota',
    leaveGroup: 'Keluar dari Grup',
    leaveGroupConfirm: 'Yakin ingin keluar dari grup ini?',
    you: 'Anda',
    groupAdmin: 'Admin',
    noMessagesYet: 'Belum ada pesan. Mulai percakapan!',
    today: 'Hari Ini',
    yesterday: 'Kemarin',
    groupInfo: 'Info Grup',
    searchInChat: 'Cari',
    searchInChatPlaceholder: 'Cari di percakapan ini...',
    noSearchResults: 'Tidak ada pesan ditemukan',
    clearChat: 'Hapus Chat',
    clearChatConfirm: 'Hapus riwayat chat ini? Hanya akan hilang untuk Anda, tidak untuk orang lain.',
    reply: 'Balas',
    edit: 'Edit',
    delete: 'Hapus',
    replyingTo: 'Membalas',
    editingMessage: 'Edit pesan',
    edited: 'diedit',
    messageDeleted: 'Pesan ini telah dihapus',
    deleteMessageConfirm: 'Hapus pesan ini?',
  },
  incomingCall: {
    title: 'Panggilan Masuk',
    connecting: 'Menghubungkan...',
    accept: 'Terima',
    reject: 'Tolak',
    noSession: 'Tidak ada sesi panggilan aktif.',
    callDeclined: 'menolak panggilan',
    addPerson: 'Tambah Orang',
    inviteToCall: 'Undang ke Panggilan',
    searchUser: 'Cari pengguna...',
    groupCall: 'Panggilan Grup',
    participants: 'peserta',
    inviteSent: 'Undangan terkirim',
    inviteFailed: 'Gagal mengirim undangan',
  },
  tripGroup: {
    title: 'Grup Perjalanan',
    hint: 'Task untuk customer yang sama yang dikerjakan dalam satu perjalanan. Dokumen perjalanan bersama dan daftar bawaan checker berlaku untuk semua task di grup.',
    empty: 'Task ini belum tergabung di grup perjalanan.',
    addTask: 'Tambah Task',
    chooseTask: 'Pilih task dalam perjalanan yang sama',
    noCandidates: 'Tidak ada task aktif lain untuk customer ini.',
    needClient: 'Isi customer task ini terlebih dahulu.',
    currentTask: 'Task ini',
    remove: 'Keluarkan',
    removeConfirm: 'Keluarkan task ini dari grup perjalanan? Dokumen miliknya ikut keluar dan task ini membawa salinan daftar bawaan.',
    checkerConflictTitle: 'Checker berbeda',
    checkerConflictMsg: 'Checker task ini ({task}) berbeda dengan checker grup ({group}). Ganti checker task ini menjadi {group}?',
    changeChecker: 'Ganti checker',
    mergeTitle: 'Gabungkan daftar bawaan',
    mergeMsg: 'Task ini sudah punya persiapan checker sendiri. Qty item yang sama akan dijumlahkan:',
    mergeConfirm: 'Gabungkan',
    hasPreparation: 'Sudah ada persiapan',
    checker: 'Checker',
    sharedDoc: 'Bersama',
    sharedFrom: 'Dibagi dari',
    shareToggle: 'Dokumen bersama grup perjalanan',
    shareHint: 'Tampil dan bisa diedit dari semua task di grup.',
    lastEditedBy: 'Terakhir diedit oleh',
    vessel: 'Kapal',
    vesselShared: 'Bersama',
    installedTitle: 'SN Terpasang',
    installedHint: 'Catat serial number yang benar-benar dipasang di kapal ini. Hanya SN ini yang ditautkan ke data produk.',
    pickFromPrepared: 'Dari bawaan checker',
    usedOn: 'Terpasang di',
    manualEntry: 'SN lain',
    itemLabel: 'Item',
    chooseItem: 'Pilih item',
    serialPlaceholder: 'Serial number',
    add: 'Tambah',
    noneInstalled: 'Belum ada SN yang dicatat.',
    noPrepared: 'Tidak ada installation item di daftar bawaan.',
    serialUsed: 'SN ini sudah tercatat terpasang di {vessel}',
    linkedTo: 'Ditautkan ke',
    tab: 'Grup',
    menuAdd: 'Tambah ke Grup Perjalanan',
    chip: 'Grup · {n} kapal',
  },
};
